import React from 'react';
import { Auth, Hub } from 'aws-amplify';
import { get } from '@ts/utils/cs';

export const AuthContext = React.createContext(null);

function AuthProvider(props) {
    const [user, setUser] = React.useState(null);
    const [loading, setLoading] = React.useState(true);

    const value = React.useMemo(
        () => ({
            user,
            loading,
            setUser,
        }),
        [user, loading, setUser]
    );

    React.useEffect(() => {
        Hub.listen('auth', ({ payload: { event, data } }) => {
            switch (event) {
                case 'signIn':
                    setUser(data);
                    break;
                case 'cognitoHostedUI':
                    setUser(data);
                    break;
                case 'signOut':
                    setUser(null);
                    break;
                case 'customOAuthState':
                    break;
                default:
                    break;
            }
        });

        setLoading(true);
        Auth.currentAuthenticatedUser()
            .then((data) => {
                setUser(data);
                const userInfo = get('user');
                const payload = {
                    email: data.email,
                    firstName: data.given_name,
                    lastName: data.family_name ? data.family_name : userInfo.lastName,
                    fullName: data.firstname + ' ' + data.family_name || userInfo.lastName,
                    picture: userInfo.picture,
                };
                document.cookie = 'user=' + JSON.stringify(payload);
                return data;
            })
            .finally(() => {
                setLoading(false);
            });
    }, []);

    return <AuthContext.Provider value={value}>{props.children}</AuthContext.Provider>;
}

export default AuthProvider;
